export const accountDeletedRoute = '/account-deleted';
export const exercisesBigRoute = '/lp/exercises-big';
export const exercisesBigFrontpageRoute = '/lp/frontpage/exercises-big';
export const exercisesBigWhiteRoute = '/lp/exercises-big-white';
export const exercisesBigFrontpageWhiteRoute = '/lp/frontpage/exercises-big-white';
export const exercisesDeviceRoute = '/lp/exercises-device';
export const exercisesDeviceFrontpageRoute = '/lp/frontpage/exercises-device';
export const exercisesDeviceWhiteRoute = '/lp/exercises-device-white';
export const exercisesDeviceFrontpageWhiteRoute = '/lp/frontpage/exercises-device-white';
export const questionnaireRoute = '/questionnaire';
export const nativeRoute = '/lp/native';
export const testimonialRoute = '/lp/videofeedback/andrean';
export const testimonialOnboardingCTARoute = '/lp/videoandrean';
export const goRoute = '/lp/go/*';
export const corpRoute = '/lp/corp/*';
export const quizRoute = '/quiz';
export const blogGoRoute = '/lp/blog_go/:locaId?/*';
export const prescriptionServiceRoute = '/prescriptionService';
export const medPrescriptionServiceRoute = '/med/prescriptionService';
export const medReprescriptionServiceRoute = '/med/represcriptionService';
export const medReprescriptionServiceRoutev2 = '/med/represcriptionServiceV2';
export const medInstantPrescriptionServiceRoute = '/med/instantPrescriptionService';
export const medNewPrescriptionServiceRoute = '/med/prescriptionServiceV2';
export const legalsRoute = '/legals/:type';
export const galleryRoute = '/gallery/*';
export const assessmentRoute = 'assessment/*';
export const evaluationRoute = 'evaluation/*';
export const welcomeRoute = 'welcome/*';
export const notAuthorizedRoute = 'not-authorized';

// Go subroutes
export const goHomeRoute = '';
export const goExercisesRoute = 'exercises';
export const goScienceRoute = 'science';

// Blog go subroutes
export const blogGoHomeRoute = ':locaId?';
export const blogGoExercisesRoute = ':locaId?/exercises';
export const blogGoScienceRoute = ':locaId?/science';

// Corp subroutes
export const corpHomeRoute = '';
export const corpExercisesRoute = 'exercises';
export const corpScienceRoute = 'science';

// Welcome subroutes
export const welcomeHomeRoute = '';
export const welcomeMascotRoute = 'mascot';
export const welcomeVideoRoute = 'video';

export enum EAppRoutes {
  Welcome = 'welcome',
  Error = 'error',
  NotAuthorized = 'not-authorized',
  Assessment = 'assessment',
  Evaluation = 'evaluation',
}

export enum EEvaluationRoutes {
  Intro = '/intro',
  PeerGroup = '/peergroup',
  Evaluation = '/evaluation',
  Schedule = '/schedule',
  SpecialNeeds = '/special-needs',
  Led = '/led',
}

export function isAssessmentPage(pathname: string) {
  return pathname.includes(EAppRoutes.Assessment);
}

function isEvaluationPage(pathname: string) {
  return pathname.includes(EAppRoutes.Evaluation);
}

export function isPostRegPage(pathname: string) {
  // TODO: add more routes after separating pages (BW-7363)
  return isAssessmentPage(pathname) || isEvaluationPage(pathname);
}

export function isWelcomePage(pathname: string) {
  return pathname.endsWith(EAppRoutes.Welcome) || pathname === '/';
}

export function isLPPage(pathname: string) {
  return pathname.includes('lp/');
}
